import React, { useState, useEffect } from 'react';
import GTMDataLayer from './gtm';

const FilterIndustry = (props) => {
  const [handleAction, setHandleAction] = useState(false);

  const checked = () => {
    if (props.checked) {
      return props.checked.split('-');
    }
    else {
      return [];
    }
  }
  const [checkedIndustries, setCheckedIndustries] = useState(checked());

  const handleFilterIndustry = (e) => {
    if (e.target.checked) {
      setCheckedIndustries([...checkedIndustries,  e.target.id]);
      
      // Track industry changes.
      GTMDataLayer({
        event: 'filter_industry',
        pageUrl: location.href,
        filter_industry: e.target.getAttribute("data-industry")
      });
    }
    else {
      setCheckedIndustries(checkedIndustries.filter((element) => { return element !== e.target.id}));
    }
    setHandleAction(true);    
  };

  useEffect(() => {
    if (!handleAction) {
      return;
    }
    props.setFilters({...props.filters, industry: checkedIndustries.join('-'), page: 0});
  }, [checkedIndustries]);

  return (
    <div className='filter-industry'>
      <h3>{Drupal.t('Industry')}</h3>
      <div>
        {props.industry.map((item, i) => (
          <label key={i} className={(item.count == 0) ? 'disabled' : ''}>
            <input
              type="checkbox"
              value={item.tid}
              onChange={handleFilterIndustry}
              id={item.tid}
              data-industry={item.name}
              checked={checkedIndustries.includes(item.tid)}
              disabled={item.count == 0 && 'disabled'}
            />
            {item.name} <span className='count'>{item.count}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default FilterIndustry;